import React from "react";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./AddImage.css";
import { Grid, Button } from "@mui/material";
import { useFormik } from "formik";
import { validationSchemaImages } from "./ValidationSchema";

const AddImages = (props) => {
  const { handleSubmit, prevStep, Values } = props;
  const [selectedImages, setSelectedImages] = useState([]);
  const [Map, setMap] = useState({});
  const [Thumbnail, setThumbnail] = useState(null);

  const onSelectFile = (event) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray = Array.from(selectedFiles);
    const imagesArray = selectedFilesArray.map((file) => {
      let url = URL.createObjectURL(file);
      //A map is created to store {url:file} mapping
      setMap((previousMap) => ({
        ...previousMap,
        [url]: file,
      }));
      return url;
    });

    //Updating the selected Images
    setSelectedImages((previousImages) => previousImages.concat(imagesArray));

    //If only One image is selected then we should make it the Thumbnail
    if (selectedImages.length === 0) {
      let thumb = imagesArray[0];
      setThumbnail(thumb);
    }

    //For Bug in Chrome
    event.target.value = "";
  };
  function deleteHandler(image) {
    //Removing the image from the SelectedImages array
    setSelectedImages(selectedImages.filter((e) => e !== image));
    URL.revokeObjectURL(image);
    //Removing the entry of the image from the Map
    setMap((current) => {
      const copy = { ...current };
      delete copy[image];
      return copy;
    });
  }
  //Sets the selected Image as Thumbnail
  function Thumbnailer(image) {
    setThumbnail(image);
  }

  //Removes the selected Image from Thumbnail
  function ThumbnailRemover(image) {
    setThumbnail(null);
  }

  const formik = useFormik({
    initialValues: {
      image: Values.image,
      thumbnail: Values.thumbnail,
    },
    validationSchema: validationSchemaImages,
    onSubmit: (values) => {
      if (Object.keys(Map).length === 0) {
        // set formik error
        formik.setErrors({
          image: "Please select atleast one image",
        });
        return;
      }

      let arr = Object.values(Map);
      let thumb = null;
      for (let [key, value] of Object.entries(Map)) {
        if (key === Thumbnail) {
          thumb = value;
        }
      }
      // setValues({
      //   ...Values,
      //   image: arr,
      //   thumbnail: thumb,
      // });
      // update the values in formik
      // formik.setValues({
      //   image: arr,
      //   thumbnail: thumb,
      // });

      // update the values in Values
      Values.image = arr;
      Values.thumbnail = thumb;
      // call the next function
      handleSubmit();
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid
          container
          direction="column"
          sx={{
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <section>
            <label className="LABEL">
              + Add Images
              <br />
              <span>(up to 8 images)</span>
              <input
                type="file"
                name="images"
                onChange={onSelectFile}
                multiple
                accept="image/png , image/jpeg, image/webp, image/jpg"
              />
            </label>

            <input type="file" multiple />

            {selectedImages.length > 0 &&
              (selectedImages.length > 8 ? (
                <p className="error">
                  You can't upload more than 8 images! <br />
                  <span>please delete them </span>
                </p>
              ) : (
                <></>
              ))}

            <div className="images">
              {selectedImages &&
                selectedImages.map((image, index) => {
                  return (
                    <div key={image} className="image">
                      <img src={image} height="200" alt="upload" />
                      {Thumbnail === image ? (
                        <></>
                      ) : (
                        <button
                          className="Deleter"
                          onClick={(e) => {
                            e.preventDefault();
                            deleteHandler(image);
                          }}
                        >
                          <CloseIcon />
                        </button>
                      )}

                      <br />
                      {selectedImages.length <= 1 ? (
                        <></>
                      ) : (
                        <>
                          {Thumbnail === image ? (
                            <button
                              className="ThumbnailRemover"
                              onClick={(e) => {
                                e.preventDefault();
                                ThumbnailRemover(image);
                              }}
                            >
                              Remove Thumbnail
                            </button>
                          ) : (
                            <button
                              className="Thumbnailer"
                              onClick={(e) => {
                                e.preventDefault();
                                Thumbnailer(image);
                              }}
                            >
                              Make Thumbnail
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
            </div>
          </section>
        </Grid>
        {/* show formik error */}
        {formik.errors.image && <p className="error text-red-500">{formik.errors.image}</p>}

        <div className="flex justify-end gap-2">
          <Button
            onClick={(e) => {
              e.preventDefault();
              prevStep();
            }}
            variant="contained"
            className="bg-[#3671D5] hover:bg-[#114AAA] text-white"
          >
            Back
          </Button>
          <Button
            type="submit"
            className="bg-[#3671D5] hover:bg-[#114AAA] text-white"
          >
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};

export default AddImages;
